import { Fragment, useContext, useEffect, useState } from "react";
import { walletNoCard } from "../../../assets/imageImport";
import { WalletCardSkeleton } from "../../../Skeleton/myWallet/walletCardSkeleton";
import { BacktoMyAccount } from "../backToMyAccount";
import { MyWalletCardList } from "./myWalletcardList";
import { MyWalletNoCard } from "./myWalletNoCard";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { PAGES } from "../../../routeConfig";
import { GlobalContext } from "../../../Context/GlobalContext";
import { isValidArray } from "../../../Layout/Common/common";
import { Link, useParams } from "react-router-dom";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";

export const MyWalletMain = () => {
  const { storedCard, setStoredCard } = useContext(GlobalContext);
  const [cardList, setCardList] = useState(null);
  const { transId } = useParams();
  const { loadStoredCard } = useGlobalFunction();
  useEffect(() => {
    setCardList(storedCard);
  }, [storedCard]);

  useEffect(() => {
    setStoredCard(null);
    loadStoredCard();
  }, []);

  const getResponseDetails = async (transId) => {};

  return (
    <Fragment>
      <BreadCrumb
        data={[
          { name: "My Account", url: "/myaccount" },
          { name: "My Wallet", url: PAGES.MYWALLET },
        ]}
      />
      <section className="myAccount-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header-inner">
                  <h1 className="myaccount-title">My Wallet</h1>
                  <div className="order-invoice myFavoriteList">
                    <p>
                      Save your cards securely online for fast, hassle-free
                      checkout
                    </p>
                  </div>
                </div>
                <div className="fav-search">
                  <div className="button-effect">
                    <Link
                      to={PAGES.MYWALLETADD}
                      className="btn btn-products theme-primary px-3 mt-2 mt-md-0 fs-14"
                    >
                      <i className="fa-solid fa-plus" /> Add New Card
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {!cardList ? (
              <WalletCardSkeleton />
            ) : isValidArray(storedCard) ? (
              <MyWalletCardList data={storedCard} />
            ) : (
              <MyWalletNoCard />
            )}
            <BacktoMyAccount />
          </div>
        </div>
      </section>
    </Fragment>
  );
};
